export class MailsMeSearchParams {
  //? Tag : Search mail tag
  //? Default value: all
  Tag?:
    | string
    | 'All'
    | 'Lus'
    | 'NonLus'
    | 'APrendreEnCharge'
    | 'Epingles'
    | 'AValider'
    | 'PrisEnCharge'
    | 'NonPrisEnCharge'
    | 'PourAction'
    | 'ACompleter'
    | 'ADistribuer'
    | 'PourInfo'
    | 'MalRoutes'
    | 'AClasser'
    | 'Echeancier';

  //? Type : Incoming/Oncoming type
  // //? Default value: all
  Type?: string | 'All' | 'E' | 'Entrant' | 'S' | 'Sortant' | 'I' | 'Interne';

  TypeDtEntree?: 'All' | 'UC' | 'UtilisateurConnecte';

  //? Key : Searck key: Id (equals) or RefExpediteur, ReferenceRecommande, Objet, Remarques, CodeArchive (contains)
  Key?: string;

  //? Id : Search by id (equals)
  Id?: number;

  //? IdStartWith : Search by id (Starting with)
  IdStartWith?: number;

  //? DtEntreeMin : Minimum creation date
  DtEntreeMin?: string;

  //? DtEntreeMax : Maximum creation date
  DtEntreeMax?: string;

  //? SvcPropIds : List of Services propriétaires IDs
  SvcPropIds?: number[];

  //? StIds : List of status Ids
  StIds?: number[];

  //? MultipleStIds : List of tags Ids !!Multiple statutes isn't linked to status, it's a different thing. It's the mail's tags (étiquettes). The name comes for the famous Infodoc, never modified...
  MultipleStIds?: number[];

  //? ExpediteurIdiAdmins : List of senders from iAdmin (Only Users Contacts ID)
  ExpediteurIdiAdmins?: number[];

  //? ExpediteurIds : List of senders from iCourrier (Only External Contacts IDs)
  ExpediteurIds?: number[];

  //? DestinataireIdiAdmins : List of recipients from iAdmin (Type User)
  DestinataireIdiAdmins?: number[];

  //? DestinataireIds : List of recipients from iCourrier (Not User)
  DestinataireIds?: number[];

  //? DestinataireServiceIds : List of services Ids that are recipients
  DestinataireServiceIds?: number[];

  //? NatureIds : List of natures
  NatureIds?: number[];

  //? SourceIds : List of sources
  SourceIds?: number[];

  //? ClassementIds : List of classification codes Ids
  ClassementIds?: number[];

  //? ClasseurId : List of binders ids
  ClasseurId?: number[];

  //? ChemiseId : List of folders ids
  ChemiseId?: number[];

  //? Lu :  Mail read or not (if used TAG is NOT Lu or Nonlu)
  Lu?: boolean;

  //? Confidentiel : If mail is confidential or not
  Confidentiel?: boolean;

  //? DtEcheanceMin : Minimum deadline date
  DtEcheanceMin?: string;
  //? DtEcheanceMax : Maximum deadline date
  DtEcheanceMax?: string;

  //? DtConsultMin : Minimum consultation date
  DtConsultMin?: string;
  //? DtConsultMax : Maximum consultation date
  DtConsultMax?: string;

  //? DtEncodageMin : Minimum date Encodage
  DtEncodageMin?: string;
  //? DtEncodageMax : Max date Encodage
  DtEncodageMax?: string;

  //? DtDocumentMin : Minimum date Document
  DtDocumentMin?: string;
  //? DtDocumentMax : Max date Document
  DtDocumentMax?: string;

  //? DtPostaleMin : Minimum date postal
  DtPostaleMin?: string;
  //? DtPostaleMax : Max date postal
  DtPostaleMax?: string;

  DtCreationMin?: string;
  DtCreationMax?: string;

  //? Objet : Search Objet
  Objet?: string;

  //? Remarques : Search remarques
  Remarques?: string;

  //? Text : Search text words in files, required to use full-text search feature in all files
  Text?: string;

  //? TextExclude : search in files that do not contain this text
  TextExclude?: string;

  //? TextPhrase : Search as phrase in files
  TextPhrase?: boolean;

  //? CalcTotal : Calculate total items count and return the value in response. BE CAREFUL it will slow down A LOT the search if the amount of mails is huge
  // //? Default value: true
  CalcTotal?: boolean;

  //? TotalOnly : Only calculate total items count and don't return the value/data in response
  // ? You'd better use this params instead of CalcTotal = true if you have a lot of mails. Takes less time to calculate
  TotalOnly?: boolean;

  //? BoiteArchive : Search on Boite Archive string
  BoiteArchive?: string;

  //? LienTypeEqual : True for Equal, False for Not Equal, Null for All Type
  LienTypeEqual?: boolean;

  //? ReferenceRecommande : Search on Reference Recommande string
  ReferenceRecommande?: string;

  //? ExpediteurLibre : Search on Expediteur Libre string
  ExpediteurLibre?: string;

  //? DestinataireLibre : Search on Destinataire Libre string
  DestinataireLibre?: string;

  //? CourrierSansDestinataires : Courrier(s) sans destinataires
  CourrierSansDestinataires?: boolean;

  //? CourrierSansServices : Courrier(s) sans services destinataires
  CourrierSansServices?: boolean;

  //? IsAdvancedSearch : Determines if the search is an advanced search
  IsAdvancedSearch?: boolean;

  //? BacIds : List of bac ids
  BacIds?: number[];

  //? IncludeDeletedMails : if true, search also on deleted Mails
  IncludeDeletedMails?: boolean;

  //? CreatedByUserId : UserId who create the mail
  CreatedByUserId?: number;

  //? NatureCustomFieldsSearch : List of complementary natures to search on (fully dynamic by the nature chosen)
  NatureCustomFieldsSearch?: object[];

  //? ExportNatureCustomDatas : Include Nature Custom Data in Reponse
  ExportNatureCustomDatas?: boolean;

  //? SortFields : Sort fields seperated by ','
  SortFields?: string;

  //? SortOrder : Sort order, the default value: 'asc' .
  SortOrder?: 'ASC' | 'DESC';

  //? PageNumber : The default value: 1
  PageNumber?: number;

  //? PageSize : The default value: 200 for mails, 50 for scans, else 100
  PageSize?: number;
}
